import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'

function Homepage() {
    const navigate = useNavigate();
    console.log("HOME");
    useEffect(() => {
        const access_token = Cookies.get('access_token');
        if(access_token) {
            navigate('/projects/list?category=Active');
        }
        else {
            navigate('/login');
        }
    })
    return (
        <div>
        </div>
    );
}

export default Homepage;